module.exports = __webpack_public_path__ + "img/Slice1en-min.d068aca3.png";